import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { IDeliveryItem } from "../../../../../models/deliveryItem";
import { isNullOrEmpty } from "../../../../../utils/helper";

interface UseDeliveryItemFormValidationProps {
  formData: IDeliveryItem;
  existingPositions: number[];
  setIsFormValid: (isValid: boolean) => void;
}

const requiredFields: (keyof IDeliveryItem)[] = [
  "position",
  "material",
  "quantity",
  "unitOfMeasurement",
  "stockType",
];

const useDeliveryItemFormValidation = (
  props: UseDeliveryItemFormValidationProps,
) => {
  const { t } = useTranslation();
  const { formData, existingPositions, setIsFormValid } = props;

  const [positionError, setPositionError] = useState<string>();

  const validatePosition = (value: string) => {
    const position = parseInt(value, 10);
    if (isNaN(position) || position % 10 !== 0) {
      setPositionError(t("positionStepError"));
      return;
    }

    const isUnique = !existingPositions.some((pos) => pos === position);
    if (!isUnique) {
      setPositionError(t("positionUniqueError"));
      return;
    }

    setPositionError(undefined);
  };

  useEffect(() => {
    const isFormValid =
      requiredFields.every((field) => !isNullOrEmpty(formData[field])) &&
      !positionError;

    setIsFormValid(isFormValid);
  }, [formData, setIsFormValid]);

  return { positionError, validatePosition };
};

export default useDeliveryItemFormValidation;
